/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  createContext,
  useCallback,
  useState,
  useContext,
  useEffect,
} from "react";
import api from "../services/axios";
import socketIOClient from "socket.io-client";
import publicIp from "public-ip";
import CryptoJS from "crypto-js";

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [userLoaded, setUserLoaded] = useState(false);
  const [data, setData] = useState({});
  const [socket, setSocket] = useState(null);
  const [userIdChangePassword, setUserIdChangePassword] = useState(null);
  const [changePassword, setChangePassword] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  const startSocket = async (userId) => {
    if (socket) {
      socket.disconnect();
      setSocket(null);
    }

    let myIp;

    try {
      myIp = await publicIp.v6();
    } catch {
      try {
        myIp = await publicIp.v4();
      } catch (err) {
        console.log("err", err);
      }
    }

    const newSocket = socketIOClient(process.env.REACT_APP_API_URL_SOCKET, {
      query: {
        userId: userId,
        ip: myIp,
        isPaused: Boolean(sessionStorage.getItem("@Omni:isPaused")),
        companyId: sessionStorage.getItem("@Omni:CompanySelected"),
      },
    });
    setSocket(newSocket);
  };

  const getToken = async () => {
    //await updateToken();
    let token;
    if (sessionStorage.getItem("@Omni:token")?.length > 0) {
      token = CryptoJS.AES.decrypt(
        sessionStorage.getItem("@Omni:token")?.toString(),
        "@Omni:Inhouse"
      ).toString(CryptoJS.enc.Utf8);
    }
    const user = sessionStorage.getItem("@Omni:user");

    if (token && user) {
      const parsedUser = JSON.parse(user);

      startSocket(parsedUser.id);

      api.defaults.headers.Authorization = `Bearer ${token}`;

      setData({ token, user: parsedUser });
    }

    setUserLoaded(true);
  };

  useEffect(() => {
    getToken();
  }, []);

  const signIn = useCallback(async ({ login, password }) => {
    const response = await api.post("/authentications/admin", {
      login,
      password,
    });

    if (!response.data.success) {
      throw new Error(response.data.message ?? "login inválido");
    }

    const { token, ...user } = response.data.data;

    sessionStorage.setItem(
      "@Omni:token",
      CryptoJS.AES.encrypt(token, "@Omni:Inhouse")
    );
    sessionStorage.setItem("@Omni:user", JSON.stringify(user));

    api.defaults.headers.Authorization = `Bearer ${token}`;

    setData({ token, user });

    startSocket(user.id);

    return user.status;
  }, []);

  const signOut = async () => {
    sessionStorage.removeItem("@Omni:token");
    sessionStorage.removeItem("@Omni:user");

    //api.defaults.headers.authorization = null;
    delete api.defaults.headers.Authorization;

    if (socket) {
      socket.disconnect();
      setSocket(null);
    }

    setData({});
  };

  const updateUser = useCallback(
    async (user) => {
      sessionStorage.setItem("@Omni:user", JSON.stringify(user));
      setData({
        token: data.token,
        user,
      });
    },
    [setData, data.token]
  );

  api.interceptors.response.use(
    (response) => {
      if (response.data.message === "Unauthorized") {
        signOut();
        window.location.href = "/";
      }
      return response;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  return (
    <AuthContext.Provider
      value={{
        data,
        changePassword,
        setChangePassword,
        setUserIdChangePassword,
        userIdChangePassword,
        user: data.user,
        socket,
        signIn,
        signOut,
        updateUser,
        getToken,
        isPaused,
        setIsPaused,
      }}
    >
      {userLoaded ? children : <div>Carregando...</div>}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}

export { AuthProvider, useAuth };
